module.exports = __webpack_public_path__ + "01_long_gray.32304215.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_long_gray.png
// module id = oO4P
// module chunks = 0